export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11583.0e587fe1.jpg";